import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import * as moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-gestion-fip',
  templateUrl: './gestion-fip.component.html',
  styleUrls: ['./gestion-fip.component.css']
})
export class GestionFipComponent implements OnInit {
  @Input() detail;
  @Input() bon;
  @Input() retourFIPDevis;
  @Input() isDD: Boolean;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() isDevis: Boolean;
  @Input() pasFicheClient: Boolean;
  @Input() isDepuisMenuEnHaut: Boolean;
  @Input() isDepuisEcodechet: Boolean;
  
  @Output() show = new EventEmitter<any>();
  @Output() listSaved = new EventEmitter<any[]>();

  listFIP = [];
  listFIPTMP = [];
  selected = [];
  dataArticle = [];
  dataRubrique = [];
  dataMotif = [];
  listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
  listeAgence = [{ id: 0, libelleObjetEntite: 'Toutes' }];
  listeZone = [{ id: 0, libelleObjetEntite: 'Toutes' }];
  isEmpty: Boolean = true;
  renderTable: Boolean = true;
  isHisto: Boolean = false;
  hideRemorque: Boolean = false;
  isFamille2: Boolean = false;
  isPNArt: Boolean = false;
  isEdit: Boolean = false;
  isClick: Boolean = false;
  default = 0;
  societe;
  classPresta: String = 'detailfact ';
  focusIndex = 0;
  selectedRow: any = {};
  error = '';
  isDroitModifierPrixNego = false;
  articleHover: any = {};
  isFIPParSite

  @ViewChild('msg') msg;
  @ViewChild('xls') xls;
  @ViewChild('loading') loading;
  loadingIndicator: boolean;
  modalRef: BsModalRef;

  constructor(public common: CommonService, private modalService: BsModalService) {
    this.societe = this.common.local.getObject('paramSociete') || {};
  }

  ngOnInit() {
    const userDetail = this.common.local.getObject('userDetail');
    this.isDepuisMenuEnHaut = this.isDepuisMenuEnHaut || false;
    console.log('isDepuisMenuEnHaut=' + this.isDepuisMenuEnHaut);
    this.bon = this.bon || {};
    this.isClick = false;

    this.reload();
  }

  hide() {
    this.show.emit();
  }

  editRow(row) {
    this.isEdit = true;
    this.selectedRow = Object.assign({}, row);
  }

  reload() {
    if (!this.pasFicheClient) {
      this.getListFIP().then(data => {
        this.isEmpty = false;
      });
    } else {
      this.detail = this.bon['client'] || {};
      this.getListFIPPasFiche().then(data => {
        this.isEmpty = false;
      });
    }
  }

  showHisto() {
    this.isHisto = !this.isHisto;
    this.reload();
  }

  getListFIP() {
    const user = this.common.local.getObject('userDetail') || {};
    this.detail['nomclass'] = 'Client';
    this.loadingIndicator = true;
    this.listFIP = [];
    const param = {
      'servlet': this.isDD ? 'DBGestionFipDD' : 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || '0'
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'IS_USERMULTISITEFIP': {
          'typeParam': 'boolean',
          'valeur': user.isUserMultiSiteFIP || false
        },
        'IS_LIMIT_ONE_YEAR': {
          'typeParam': 'boolean',
          'valeur': true,
        },
        'IS_HISTO': {
          'typeParam': 'boolean',
          'valeur': this.isHisto || false,
        }
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      const listFIP = [];
      this.listFIPTMP = [];
      let idxModele = 1; // index du datatable

      if (this.isDD) {
        (datas.data || []).filter(row => {
          this.listFIPTMP.push(Object.assign({}, row));
          if ((row.article && row.article.id)) {
            row['idxModele'] = idxModele++;
            listFIP.push(row);
          }
        });
      } else {
        (datas.data || []).filter(row => {
          this.listFIPTMP.push(Object.assign({}, row));
          if (this.societe.isFIPCET || (row.nomenclatureICPE && row.nomenclatureICPE.id)) {
            row['idxModele'] = idxModele++;
            listFIP.push(row);
          }
        });
      }

      this.listFIP = [...listFIP];
      this.listFIP.forEach(row => {
        row.artLibelle = '';
        if (this.isDD) {
          if (row.article && row.article.id) {
            row.artLibelle = (row.article.code ? row.article.code + '/' : '') + (row.article.libelle || '');
          }
        } else {
          if (row.article && row.article.id) {
            row.artLibelle = (row.article.code ? row.article.code + '/' : '') + (row.article.libelle || '');
          }
        }

        if (row.dateCreation) {
          row.dateCreation = moment(row.dateCreation, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
          row.dateFilter = this.common.parseDate(row.dateCreation);
          row.modelDebut = this.common.parseDate(row.dateCreation);
        }
        row.chantierLibelle = row.chantier && row.chantier.id > 0 ? row.chantier.numChantier : 'Tous';
        row.chantierRespVille = row.chantier ? `${row.chantier.responsable || ''}/${row.chantier.ville || ''}` : '';
      });
      this.loadingIndicator = false;
      return datas.data;
    });
  }

  getListFIPPasFiche() {
    const user = this.common.local.getObject('userDetail') || {};
    this.loadingIndicator = true;
    this.listFIP = [];
    this.bon = this.bon || {}
    this.bon['nomclass'] = 'Bon';
    let param: any = {};
    let prom;

    if (this.isDevis) {
      this.isEmpty = false;
      this.bon['nomclass'] = 'Devis';
      param = {
        'servlet': this.isDD ? 'DBGestionFipDD' : 'DBGestionFipDND',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'forcerSerialisation': 'true',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 7
          },
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': this.bon['client'] ? this.bon['client'].id || '0' : 0
          },

          'ANNEE_BON': {
            'typeParam': 'int',
            'valeur': moment(this.bon['dateCreation'], 'DD/MM/YYYY').format('YYYY')
          },
          'DEVIS': this.bon,
        }
      };

      if (this.isDD) {
        param.data['CLEF_CHANTIER'] = {
          'typeParam': 'int',
          'valeur': this.bon['chantier'] ? this.bon['chantier'].id || '0' : 0
        };
      }
      this.getListFIPAffiche(this.retourFIPDevis);
      return Promise.resolve()
    } else {
      this.bon['nomclass'] = 'Bon';
      param = {
        'servlet': this.isDD ? 'DBGestionFipDD' : 'DBGestionFipDND',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'forcerSerialisation': 'true',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 5
          },
          'CLEF_CLIENT': {
            'typeParam': 'int',
            'valeur': this.bon['client'] ? this.bon['client'].id || '0' : 0
          },
          'CLEF_CHANTIER': {
            'typeParam': 'int',
            'valeur': (!this.bon['client'] || (this.bon['client'] && !this.bon['client'].id))
              || (!this.bon['chantier'] || (this.bon['chantier'] && !this.bon['chantier'].id)) ?
              0 : (this.bon['chantier'] ? this.bon['chantier'].id || '0' : 0)
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': this.common.user[2]
          },
          'ANNEE_BON': {
            'typeParam': 'int',
            'valeur': moment(this.bon['date'], 'DD/MM/YYYY').format('YYYY')
          },
          'BON': this.bon,
          'IS_ANGULAR': {
            'typeParam': 'boolean',
            'valeur': true
          },
        }
      }
      return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      this.getListFIPAffiche(datas)
      // const listFIP = [];
      // this.listFIPTMP = [];
      // let idxModele = 1; // index du datatable

      // if (this.isDD) {
      //   (datas.data || []).filter(row => {
      //     if ((row.article && row.article.id)) {
      //       row['idxModele'] = idxModele++;
      //       listFIP.push(row);
      //     }
      //   });
      // } else {
      //   (datas.data || []).filter(row => {
      //     if (this.societe.isFIPCET || (row.nomenclatureICPE && row.nomenclatureICPE.id)) {
      //       row['idxModele'] = idxModele++;
      //       listFIP.push(row);
      //     }
      //   });
      // }

      // this.listFIP = [...listFIP];
      // this.listFIP.forEach(row => {
      //   row.artLibelle = '';
      //   if (this.isDD) {
      //     if (row.article && row.article.id) {
      //       row.artLibelle = (row.article.code ? row.article.code + '/' : '') + (row.article.libelle || '');
      //     }
      //   } else {
      //     if (row.article && row.article.id) {
      //       row.artLibelle = (row.article.code ? row.article.code + '/' : '') + (row.article.libelle || '');
      //     }
      //   }

      //   if (row.dateCreation) {
      //     row.dateCreation = moment(row.dateCreation, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
      //     row.dateFilter = this.common.parseDate(row.dateCreation);
      //     row.modelDebut = this.common.parseDate(row.dateCreation);
      //   }
      //   row.chantierLibelle = row.chantier ? row.chantier.numChantier : 'Tous';
      //   row.chantierRespVille = row.chantier ? `${row.chantier.responsable || ''}/${row.chantier.ville || ''}` : '';
      //   row['signee'] = row['signee'] || false;
      //   row['refusee'] = row['refusee'] || false;
      //   row['isLimite'] = row['isLimite'] || false;
      // });
      // this.loadingIndicator = false;

      return datas.data;
    });
    }

    
  }

  getListFIPAffiche(datas) {
    const listFIP = [];
    this.listFIPTMP = [];
    let idxModele = 1; // index du datatable
   
    if (this.isDD) {
      (datas.data || []).filter(row => {
        if ((row.article && row.article.id)) {
          row['idxModele'] = idxModele++;
          listFIP.push(row);
        }
      });
    } else {
      (datas.data || []).filter(row => {
        if (this.societe.isFIPCET || (row.nomenclatureICPE && row.nomenclatureICPE.id)) {
          row['idxModele'] = idxModele++;
          listFIP.push(row);
        }
      });
    }

    this.listFIP = [...listFIP];
    this.listFIP.forEach(row => {
      row.artLibelle = '';
      if (this.isDD) {
        if (row.article && row.article.id) {
          row.artLibelle = (row.article.code ? row.article.code + '/' : '') + (row.article.libelle || '');
        }
      } else {
        if (row.article && row.article.id) {
          row.artLibelle = (row.article.code ? row.article.code + '/' : '') + (row.article.libelle || '');
        }
      }

      if (row.dateCreation) {
        row.dateCreation = moment(row.dateCreation, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY');
        row.dateFilter = this.common.parseDate(row.dateCreation);
        row.modelDebut = this.common.parseDate(row.dateCreation);
      }
      row.chantierLibelle = row.chantier ? row.chantier.numChantier : 'Tous';
      row.chantierRespVille = row.chantier ? `${row.chantier.responsable || ''}/${row.chantier.ville || ''}` : '';
      row['signee'] = row['signee'] || false;
      row['refusee'] = row['refusee'] || false;
      row['isLimite'] = row['isLimite'] || false;
    });
    this.loadingIndicator = false;
  }

  selectRow(row) {
    this.focusIndex = this.listFIP.indexOf(row);
    this.selected = [row];
  }

  addLigne() {
    let dateCreation;
    dateCreation = this.common.parseDate(moment().format('DD/MM/YYYY'));
    this.selectedRow['modelDebut'] = dateCreation;
    this.selectedRow['ajout'] = true;
    this.selectedRow['dateCreation'] = moment().format('DD/MM/YYYY');

  }

  searchArticle(event) {
    this.dataArticle = [];
    const param = this.isDD ? 56 : 5;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataArticle = datas.data;
      } else {
        if (datas.message) {
          if (datas.message.includes('Utilisateur non authentifié')) {
            this.common.removeConnection();
          }
        }
      }
    });
  }

  searchRubrique(event) {
    this.dataRubrique = [];
    const param = 7;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataRubrique = datas.data;
      }
    });
  }

  searchMotif(event) {
    this.dataMotif = [];
    const param = 8;

    return this.common.appelComboK3Fct(param, event).then(datas => {
      // $('#autocomplete').trigger('click');
      if (datas.data) {
        this.dataMotif = datas.data;
      }
    });
  }

  searchChantier(event) {
    this.listChantier = [{ id: 0, libelleObjetEntite: 'Tous' }];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 3
        },
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || '0'
        },
        'CRITERE': event || ''
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = [...this.listChantier, ...datas.data];
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  valideFIPBeforeSave() {
    console.log('Calling valideFIPBeforeSave()');

    this.selectedRow = this.selectedRow || {};
    const row = this.selectedRow;
    if (row.chantier && row.chantier.id > 0) {
      row.chantierLibelle = row.chantier && row.chantier.id > 0 ? row.chantier.numChantier : 'Tous';
      row.chantierRespVille = row.chantier ? `${row.chantier.responsable || ''}/${row.chantier.ville || ''}` : '';
    }
    const defaultSite = this.common.local.getObject('siteUser') || {};
    if (defaultSite && defaultSite.id) {
      row.site = defaultSite
    }

    if (row.article && row.article.id > 0) {
      row.article.artLibelle = row.article.libelleObjetEntite
        || ((row.article.code ? row.article.code + '/' : '') + (row.article.libelle || ''));
    }

    if (this.isDD) {
      if (!this.selectedRow['article'] || (this.selectedRow['article'] &&
        !this.selectedRow['article'].id)) {
        this.error = 'Vous devez sélectionner un article.';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    } else {
      if (this.societe['isFIPCET']) {
        if (!this.selectedRow['article'] || (this.selectedRow['article'] &&
          !this.selectedRow['article'].id)) {
          this.error = 'Vous devez sélectionner un article.';
          this.common.openModal(this.modalService, this.msg);
          return false;
        }
      } else {
        if (!this.selectedRow['nomenclatureICPE'] || (this.selectedRow['nomenclatureICPE'] &&
          !this.selectedRow['nomenclatureICPE'].id)) {
          this.error = 'Vous devez sélectionner une rubrique.';
          this.common.openModal(this.modalService, this.msg);
          return false;
        }
      }
    }

    if (this.selectedRow['refusee'] && (!this.selectedRow['motifRefusFIP'] ||
      (this.selectedRow['motifRefusFIP'] && !this.selectedRow['motifRefusFIP'].id))) {
      this.error = 'Vous devez sélectionner un motif de refus.';
      this.common.openModal(this.modalService, this.msg);
      return false;
    }

    // Vérifie que ce n'est pas un doublon de DD/DND
    if (this.isDD) {
      if (!this.isDonneesFipDDClientValides()) {
        return false;
      }
    } else {
      if (!this.isDonneesFipDNDClientValides()) {
        return false;
      }
    }

    // On incrémente le dernier idxModele
    if (!this.selectedRow['idxModele']) { // Nouvelle ligne
      this.selectedRow['idxModele'] = this.listFIP.length ? this.listFIP[this.listFIP.length - 1]['idxModele'] + 1 : 1;
    }

    const test = this.listFIP.filter(fip => fip.id === this.selectedRow['id'])
    if (!test || (test && !test.length)) {
      this.selectedRow['id'] = -1 * (this.listFIP.length + 1);
      this.listFIP.push(Object.assign({}, this.selectedRow));
    } else {
      this.listFIP.forEach(fip => {
        if (fip.id === this.selectedRow['id']) {
          if (!this.isDD) {
            fip.nomenclatureICPE = this.selectedRow.nomenclatureICPE || { id: 0 };
          }

          fip.qteEstime = this.selectedRow.qteEstime || 0;
          fip.article = this.selectedRow.article || { id: 0 };
          fip.chantier = this.selectedRow.chantier || { id: 0 };
          fip.signee = this.selectedRow.signee || false;
          fip.refusee = this.selectedRow.refusee || false;
          fip.motifRefusFIP = this.selectedRow.motifRefusFIP || { id: 0 };
          fip.isLimite = this.selectedRow.isLimite || false;
          fip.limite = this.selectedRow.limite || 0;
          fip.annee = this.selectedRow.annee || '';
          fip.dateCreation = this.selectedRow.dateCreation || '';
        }
      });
    }
    this.listFIP = [...this.listFIP];
    this.isEdit = false;
    console.log(this.listFIP)
  }

  /**
   * Vérification doublon FIPDND
   * L'algo a été traduit sur la fonction dans PanneauFipDND.java
   */
  isDonneesFipDNDClientValides() {
    let dateNewFip = this.selectedRow['dateCreation'];
    let clefChantier = this.selectedRow['chantier'] && this.selectedRow['chantier'].id ? this.selectedRow['chantier'].id : 0;
    let idxModele = this.selectedRow['idxModele'] ? this.selectedRow['idxModele'] : -1;

    if (!this.societe.isFIPCET) {
      let clefNomenclatureICPE = this.selectedRow['nomenclatureICPE'] && this.selectedRow['nomenclatureICPE'].id ? this.selectedRow['nomenclatureICPE'].id : 0;
      if (this.isFipDNDClientEnListe(idxModele, clefNomenclatureICPE, 0, clefChantier, dateNewFip)) {
        this.error = 'La rubrique existe déjà dans la liste.';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    } else {
      let clefArticle = this.selectedRow['article'] && this.selectedRow['article'].id ? this.selectedRow['article'].id : 0;
      if (this.isFipDNDClientEnListe(idxModele, 0, clefArticle, clefChantier, dateNewFip)) {
        this.error = 'La rubrique existe déjà dans la liste.';
        this.common.openModal(this.modalService, this.msg);
        return false;
      }
    }

    return true
  }

  /**
   * Vérification doublon FIPDD
   * L'algo a été traduit sur la fonction dans PanneauFipDD.java
   */
  isDonneesFipDDClientValides() {
    let dateNewFip = this.selectedRow['dateCreation'];
    let clefChantier = this.selectedRow['chantier'] && this.selectedRow['chantier'].id ? this.selectedRow['chantier'].id : 0;
    let clefArticle = this.selectedRow['article'] && this.selectedRow['article'].id ? this.selectedRow['article'].id : 0;
    let idxModele = this.selectedRow['idxModele'] ? this.selectedRow['idxModele'] : -1;

    if (this.isFipDDClientEnListe(idxModele, clefArticle, clefChantier, dateNewFip)) {
      this.error = 'La rubrique existe déjà dans la liste.';
      this.common.openModal(this.modalService, this.msg);
      return false;
    }

    return true
  }

  /**
   *  Vérification si la dateOldFip+365 est inférieure ou égale à la dateNewFip (date de création du nouveau FIP)
   *  L'algo a été traduit sur la fonction dans PanneauFipDND.java
   */
  dateNewFipValide(dateOldFip, dateNewFip) {
    if (dateOldFip && dateNewFip) {
      let fipDateCreation = moment(dateOldFip, 'DD/MM/YYYY').add(365, 'days');
      dateNewFip = moment(dateNewFip, 'DD/MM/YYYY');
      const dateLessOrEqualToday = fipDateCreation.isSameOrBefore(dateNewFip);
      return dateLessOrEqualToday;
    }

    return true;
  }

  /**
   * Compare le FIPDND ajouté/modifié avec la liste
   * L'algo a été traduit sur la fonction dans PanneauFipDND.java
   * idxModeleAExclure : pour ne pas comparer avec lui même en cas de modifications
   */
  isFipDNDClientEnListe(idxModeleAExclure, clefNomenclatureICPE, clefArticle, clefChantier, dateNewFip) {
    const clefSiteUtilisateur = this.common.user[2] || 0;
    const nbLignes = this.listFIP.length;

    if (clefNomenclatureICPE != 0) {
      for (let i = 0; i < nbLignes; i++) {
        const fipDND = this.listFIP[i];
        if (fipDND['idxModele'] && fipDND['idxModele'] == idxModeleAExclure) continue;
        const fipDNDChantierId = fipDND.chantier && fipDND.chantier.id ? fipDND.chantier.id : 0;
        const fipDNDnomenclatureICPEId = fipDND.nomenclatureICPE && fipDND.nomenclatureICPE.id ? fipDND.nomenclatureICPE.id : 0;
        if (fipDNDnomenclatureICPEId == clefNomenclatureICPE &&
          fipDNDChantierId == clefChantier &&
          !this.dateNewFipValide(fipDND.dateCreation, dateNewFip)) {

          return true;
        }
      }
    }

    if (clefArticle != 0) {
      for (let i = 0; i < nbLignes; i++) {
        let fipDND = this.listFIP[i];
        if (fipDND['idxModele'] && fipDND['idxModele'] == idxModeleAExclure) continue;
        const fipDNDArticleId = fipDND.article && fipDND.article.id ? fipDND.article.id : 0;
        const fipDNDChantierId = fipDND.chantier && fipDND.chantier.id ? fipDND.chantier.id : 0;
        const fipDNDSiteId = fipDND.site && fipDND.site.id ? fipDND.site.id : 0;
        if (!fipDND.refusee &&
          fipDNDArticleId == clefArticle &&
          fipDNDChantierId == clefChantier &&
          !this.dateNewFipValide(fipDND.dateCreation, dateNewFip) &&
          fipDNDSiteId == clefSiteUtilisateur) {

          return true;
        }
      }
    }

    return false;
  }

  /**
   * Compare le FIPDD ajouté/modifié avec la liste
   * L'algo a été traduit sur la fonction dans PanneauFipDD.java
   * idxModeleAExclure : pour ne pas comparer avec lui même en cas de modifications
   */
  isFipDDClientEnListe(idxModeleAExclure, clefArticle, clefChantier, dateNewFip) {
    const clefSiteUtilisateur = this.common.user[2] || 0;
    const nbLignes = this.listFIP.length;

    for (let i = 0; i < nbLignes; i++) {
      let fipDD = this.listFIP[i];
      if (fipDD['idxModele'] && fipDD['idxModele'] == idxModeleAExclure) continue;
      const fipDDArticleId = fipDD.article && fipDD.article.id ? fipDD.article.id : 0;
      const fipDDChantierId = fipDD.chantier && fipDD.chantier.id ? fipDD.chantier.id : 0;
      const fipDDSiteId = fipDD.site && fipDD.site.id ? fipDD.site.id : 0;
      if (!fipDD.refusee &&
        fipDDArticleId == clefArticle &&
        fipDDChantierId == clefChantier &&
        !this.dateNewFipValide(fipDD.dateCreation, dateNewFip) &&
        fipDDSiteId == clefSiteUtilisateur) {

        return true;
      }
    }

    return false;
  }

  parsefip(fip) {
    fip.id = fip.id && fip.id > 0 ? fip.id : 0;
    if (!this.isDD) {
      fip.nomenclatureICPE = fip.nomenclatureICPE || { id: 0 };
      fip.nomenclatureICPE.id = fip.nomenclatureICPE.id || 0;
      fip.nomenclatureICPE.nomclass = 'NomenclatureICPE';
    }

    fip.qteEstime = fip.qteEstime || 0;
    fip.clefSite = fip.clefSite || (this.isDevis ? 0 : this.common.user[2]) || 0;
    fip.site = {
      id: fip.clefSite || (this.isDevis ? 0 : this.common.user[2]) || 0,
      nomclass: 'SiteEntreprise'
    };
    fip.article = fip.article || { id: 0 };
    fip.article.id = fip.article.id || 0;
    fip.article.nomclass = 'Article';
    fip.chantier = fip.chantier || { id: 0 };
    fip.chantier.id = fip.chantier.id || 0;
    fip.chantier.nomclass = 'Chantier';
    fip.signee = fip.signee || false;
    fip.refusee = fip.refusee || false;
    fip.motifRefusFIP = fip.motifRefusFIP || { id: 0 };
    fip.motifRefusFIP.id = fip.motifRefusFIP.id || 0;
    fip.motifRefusFIP.nomclass = 'MotifRefusFIP';
    fip.isLimite = fip.isLimite || false;
    fip.limite = fip.limite || 0;
    fip.annee = fip.annee || '';
    fip.dateCreation = fip.dateCreation || '';
    fip.client = {
      id: this.detail['id'] || 0,
      nomclass: 'Client'
    }
    fip.nomclass = this.isDD ? 'FipDD' : 'FipDND';
    return fip;
  }

  saveModif() {
    const LIST_FIP_DND = this.listFIP || [];
    const LIST_FIP_DND_INITIALE = this.listFIPTMP || [];
    LIST_FIP_DND.forEach(fip => fip = this.parsefip(fip));
    LIST_FIP_DND_INITIALE.forEach(fip => fip = this.parsefip(fip))
    const param = {
      'servlet': this.isDD ? 'DBGestionFipDD' : 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'IS_AT_FICHE_CLIENT': {
          'typeParam': 'boolean',
          'valeur': this.pasFicheClient ? false : true
        },
        'CLEF_MODULE': {
          'typeParam': 'int',
          'valeur': this.common.activedModule || 0
        },
        'CLEF_USER': {
          'typeParam': 'int',
          'valeur': this.common.user[0] || 0
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2] || 0
        },
      }
    };

    if (!this.isDD) {
      param.data['LIST_FIP_DND'] = LIST_FIP_DND;
      param.data['LIST_FIP_DND_INITIALE'] = LIST_FIP_DND_INITIALE;
    } else {
      param.data['LIST_FIP_DD'] = LIST_FIP_DND;
      param.data['LIST_FIP_DD_INITIALE'] = LIST_FIP_DND_INITIALE;
    }
    
    param.data['RET_LISTE'] = {
      'typeParam': 'boolean',
      'valeur': this.isDepuisEcodechet  ? true : false
    };

    return this.common.post('', { param: param }, true).then(datas => {
      if (this.common.verifySession(datas)) {
        if(datas.data && this.isDepuisEcodechet) {
            this.listSaved.emit(datas.data);
        } else {
            this.hide();
        }
      }
    });
  }


  extraireXls() {
    this.detail['nomclass'] = 'Client';
    const param = {
      'servlet': this.isDD ? 'DBGestionFipDD' : 'DBGestionFipDND',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'pathImpression': 'Recylog/tmp/',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id']
        },
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data[0]) {
          this.common.openFile(datas.data[0]);
        } else {
          if (datas.message) {
            this.error = datas.message;
            this.common.openModal(this.modalService, this.msg);
          }
        }
      }
    });
  }

  changeDateDebut(event, row) {
    if (moment(event).isValid()) {
      row['dateCreation'] = moment(event).format('DD/MM/YYYY');
    } else {
      row['dateCreation'] = moment().format('DD/MM/YYYY');
    }

  }

  selectDate(event, id) {
    this.common.focusElement(id);
  }

  changeSignee(row?) {
    if (row) {
      if (row['signee']) {
        row['refusee'] = false;
        row['motifRefusFIP'] = { id: 0 };
      }
    } else {
      if (this.selectedRow['signee']) {
        this.selectedRow['refusee'] = false;
        this.selectedRow['motifRefusFIP'] = { id: 0 };
      }
    }
  }

  validerModif() {

  }

}

